"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTAKE_URL_PARAMETERS = exports.PCI_INTAKE_HOST_US1 = exports.INTAKE_SITE_US1_FED = exports.INTAKE_SITE_EU1 = exports.INTAKE_SITE_US1 = exports.INTAKE_SITE_FED_STAGING = exports.INTAKE_SITE_STAGING = void 0;
exports.INTAKE_SITE_STAGING = 'datad0g.com';
exports.INTAKE_SITE_FED_STAGING = 'dd0g-gov.com';
exports.INTAKE_SITE_US1 = 'datadoghq.com';
exports.INTAKE_SITE_EU1 = 'datadoghq.eu';
exports.INTAKE_SITE_US1_FED = 'ddog-gov.com';
exports.PCI_INTAKE_HOST_US1 = 'pci.browser-intake-datadoghq.com';
exports.INTAKE_URL_PARAMETERS = ['ddsource', 'dd-api-key', 'dd-request-id'];
//# sourceMappingURL=intakeSites.js.map